import { css } from '@linaria/atomic'
import { styled } from '@linaria/react'
import { palette } from '../styles/colors'

export const dividerStyles = css`
    border-bottom: 1px solid ${palette.drawerDivider};
`

export const StyledDivider = styled('div')`
    border-bottom: 1px solid ${palette.drawerDivider};
`
